import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: ${variables.sectionPadding};

    .headline {
        font-weight: 700;
        font-size: 1.7em;
        color: #262626;
        margin-bottom: 1em;
    }

    .rows-container {
        width: 100%;
        display: flex;
        justify-content: flex-end;

        .row {
            width: 100%;
            border-bottom: .1em solid ${variables.colorTextLighter};
            margin-bottom: 1em;

            .clickable-title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 1em;
                cursor: pointer;

                .row-title {
                    font-size: 1.25em;
                    max-width: 80%;
                }

                .icon {
                    width: 20px;
                    font-size: 18px;
                    transition: transform 200ms ease-in-out;
                    transform: rotate(-90deg) scale(0.8);
                    color: #BA9449;
                }

                @media (pointer: fine) {
                    &:hover {
                        .icon {
                            transform: rotate(-90deg) scale(1.2);
                        }
                    }
                }
            }

            .row-description {
                margin: .7em 0 .7em 1em;
                max-height: 0;
                overflow: hidden;
            }

            &.active {
                .clickable-title {
                    .icon {
                        transform: rotate(0) scale(0.8);
                    }

                    &:hover {
                        .icon {
                            transform: rotate(0) scale(1.2);
                        }
                    }
                }

                .row-description {
                    max-height: 100%;
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        padding: ${variables.sectionPadding};

        .headline {
            text-align: center;
        }
    }
`;
